import React, { memo, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { CircularProgress } from '@material-ui/core';
import { FILE_TO_UPLOAD } from '../../../shared/utils/constants';
import defaultIcon from '../../../shared/img/filetypes/default-file.svg';
import { getDownloadService } from '../../../shared/utils/smartutils';
import SmartImage from '../../../shared/components/SmartImage';

const ChatFileViewer = (props) => {
  const {
    fileUrl,
    mimeType,
    fileSize,
    t,
    uploadFileError,
    uploadFileAgain,
    fileName,
  } = props;

  const [showCircularProgress, setShowCircularProgress] = useState(true);

  const tryAgain = () => {
    if (!showCircularProgress) {
      setShowCircularProgress(true);
    }
    uploadFileAgain();
  };
  const getDownloadAction = () => {
    return (
      <div className="chat__bubble-download-wrap">
        <p className="chat__bubble-file-name">
          {fileSize ? <span>{fileSize}</span> : null}
        </p>
        <button
          type="button"
          className="chat__bubble-download-button"
          onClick={() => getDownloadService(fileUrl, fileName)}
        >
          {t('general.download')}
        </button>
      </div>
    );
  };

  const getViewer = () => {
    if (fileUrl && mimeType) {
      if (fileUrl === FILE_TO_UPLOAD) {
        return (
          <div className="content-wrapper-iframe">
            <div className="upload-file">
              {mimeType.startsWith('audio') ? (
                <audio>
                  <track kind="captions" />
                </audio>
              ) : (
                <embed title="Upload File" src="" />
              )}
              {uploadFileError &&
              uploadFileError.hasError &&
              !showCircularProgress ? (
                <button className="file-error" type="button" onClick={tryAgain}>
                  {t('general.try-again')}
                </button>
              ) : (
                <CircularProgress size={20} className="circular-progress" />
              )}
            </div>
          </div>
        );
      }
      if (mimeType.startsWith('image')) {
        return (
          <>
            <a href={fileUrl} target="_blank" rel="noreferrer">
              <SmartImage
                src={fileUrl}
                alt={fileUrl}
                className="bg-dark"
                title={fileName}
              />
            </a>
            {getDownloadAction()}
          </>
        );
      }
      if (mimeType.startsWith('video')) {
        return (
          <>
            <video controls>
              <source src={fileUrl} type="video/mp4" />
              <track kind="captions" />
            </video>
            {getDownloadAction()}
          </>
        );
      }
      if (mimeType.startsWith('audio')) {
        return (
          <>
            <audio controls>
              <track kind="captions" />
              <source src={fileUrl} />
            </audio>
            {getDownloadAction()}
          </>
        );
      }
      if (!mimeType.includes('audio' || 'video')) {
        return (
          <>
            <a href={fileUrl} target="_blank" rel="noreferrer">
              <img src={defaultIcon} alt="Default file" title={fileName} />
            </a>
            {getDownloadAction()}
          </>
        );
      }
    }
    return null;
  };

  useLayoutEffect(() => {
    if (uploadFileError && uploadFileError.hasError) {
      setShowCircularProgress(false);
    }
  }, [uploadFileError]);

  return getViewer();
};

ChatFileViewer.propTypes = {
  fileUrl: PropTypes.string.isRequired,
  mimeType: PropTypes.string.isRequired,
  fileSize: PropTypes.string,
  t: PropTypes.func.isRequired,
  uploadFileError: PropTypes.shape({
    hasError: PropTypes.bool,
    file: PropTypes.instanceOf(File),
    messageUid: PropTypes.string,
    error: PropTypes.shape(PropTypes.shape),
  }),
  uploadFileAgain: PropTypes.func.isRequired,
  fileName: PropTypes.string.isRequired,
};

ChatFileViewer.defaultProps = {
  fileSize: undefined,
};

export default withTranslation('common')(memo(ChatFileViewer));
